// extracted by css-extract-rspack-plugin
export default {"cls1":"BigCardDiscover-cls1_ye0","cls2":"BigCardDiscover-cls2_M-I BigCardDiscover-cls1_ye0"};